import React from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import validations from "customs/helpers/validations";
import helpers from "customs/helpers/helpers";
import AuthService from "customs/auth/AuthServiceClient";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Person from "@material-ui/icons/PersonOutline";
// Import LockOutline from "@material-ui/icons/LockOutline";

// Core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import resetPasswordStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {connect} from "react-redux";
import {doResetClientPassword} from "../../../store/actions/authActions";
import { withRouter } from "react-router-dom";

class ResetPassword extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "cardAnimation": "cardHidden",
            "username_valid": "",
            "password_valid": "",
            "password_confirmation_valid": ""
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange (event) {
        this.setState({
            [event.target.id]: event.target.value,
            [`${event.target.id}_valid`]: ""
        });
    }

    componentDidMount () {
        this.timeOutFunction = setTimeout(
            () => {
                this.setState({"cardAnimation": ""});
            },
            700
        );
    }

    componentWillUnmount () {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }

  handleResetPasswordClick = (event) => {
      event.preventDefault();
      this.handleResetPassword();
  };

  handleResetPassword () {
      let error_msg = "";
      const is_valid_username = validations.validateUsername(this.state.username),
          password_valid = validations.validatePassword(this.state.password),
          password_confirmation_valid = validations.validatePassword(this.state.password_confirmation);
      if (this.state.password !== this.state.password_confirmation) {
          error_msg = "The password confirmation does not match";
      }
      if (
        is_valid_username &&
        password_valid &&
        password_confirmation_valid &&
        !error_msg
      ) {
          helpers.showLoading();
          this.props.doResetClientPassword(
              this.props.match.params.token,
              {
                  "username": this.state.username,
                  "password": this.state.password,
                  "password_confirmation": this.state.password_confirmation
              },
              {...this.props}
          );
          this.setState({
              "username_valid": "",
              "password_valid": "",
              "password_confirmation_valid": "",
              error_msg
          });
      } else {
          this.setState({
              "username_valid": is_valid_username ? "success" : "error",
              "password_valid": password_valid ? "success" : "error",
              "password_confirmation_valid": password_confirmation_valid
                  ? "success"
                  : "error",
              error_msg
          });
      }
  }

  handleKeyDown = (event) => {
      if (event.key === "Enter") {
          this.handleResetPassword();
      }
  };

  handleLoginClick = () => {
      this.props.history.push("/client/auth/login");
  };

  render () {
      if (new AuthService(
          this.state,
          this.props
      ).getToken()) {
          return (
              <div>
                  <Redirect to="/client/client/document_library" />
              </div>
          );
      }

      const {classes} = this.props;
      return (
          <div className={classes.container}>
              <GridContainer justify="center">
                  <GridItem
                      md={4}
                      sm={6}
                      xs={12}
                  >
                      <form>
                          <Card
                              className={classes[this.state.cardAnimation]}
                              login
                          >
                              <CardHeader
                                  className={`${classes.cardHeader} ${classes.textCenter}`}
                                  color="success"
                              >
                                  <h4 className={classes.cardTitle}>
                                      Password Reset
                                  </h4>
                              </CardHeader>
                              {this.props.reset_msg || this.state.error_msg
                                  ? <CardBody style={{"paddingBottom": "0px"}}>
                                      <h4
                                          className={classes.textCenter}
                                          id="reset_password_status"
                                          style={{
                                              "color": this.props.reset_status
                                                  ? this.props.reset_status
                                                  : "red",
                                              "marginBottom": "0px",
                                              "paddingBottom": "0px"
                                          }}
                                      >
                                          {(this.props.reset_msg ? this.props.reset_msg : '') + (this.state.error_msg ? this.state.error_msg : '')}
                                      </h4>
                                    </CardBody>
                                  : ""}
                              <CardBody style={{"paddingTop": "0px",
                                  "paddingBottom": "0px"}}
                              >
                                  <h5
                                      className={classes.socialLine}
                                      style={{"marginBottom": "0px",
                                          "paddingBottom": "0px"}}
                                  >
                                      Please enter a new password.
                                  </h5>
                              </CardBody>
                              <CardBody>
                                  <CustomInput
                                      error={this.state.username_valid === "error"}
                                      formControlProps={{
                                          "fullWidth": true
                                      }}
                                      helperText={
                                          this.state.username_valid === "error" && this.state.username
                                              ? "Invalid username format"
                                              : undefined
                                      }
                                      id="username"
                                      inputProps={{
                                          "endAdornment":
                                            <InputAdornment position="end">
                                                <Person className={classes.inputAdornmentIcon} />
                                            </InputAdornment>,
                                          "type": "username",
                                          "onChange": this.handleChange,
                                          "onKeyDown": this.handleKeyDown
                                      }}
                                      labelText="Username..."
                                      success={this.state.username_valid === "success"}
                                  />
                                  <CustomInput
                                      error={this.state.password_valid === "error"}
                                      formControlProps={{
                                          "fullWidth": true
                                      }}
                                      helperText={
                                          this.state.password_valid === "error" && this.state.password
                                              ? validations.passwordErrorMsg()
                                              : undefined
                                      }
                                      id="password"
                                      inputProps={{
                                          "endAdornment":
                                            <InputAdornment position="end">
                                                <Icon className={classes.inputAdornmentIcon}>
                                                    lock_outline
                                                </Icon>
                                            </InputAdornment>,
                                          "type": "password",
                                          "autoComplete": "off",
                                          "onChange": this.handleChange,
                                          "onKeyDown": this.handleKeyDown
                                      }}
                                      labelText="Password"
                                      success={this.state.password_valid === "success"}
                                  />
                                  <CustomInput
                                      error={this.state.password_confirmation_valid === "error"}
                                      formControlProps={{
                                          "fullWidth": true
                                      }}
                                      helperText={
                                          this.state.password_confirmation_valid === "error" && this.state.password_confirmation
                                              ? validations.passwordErrorMsg()
                                              : undefined
                                      }
                                      id="password_confirmation"
                                      inputProps={{
                                          "endAdornment":
                                            <InputAdornment position="end">
                                                <Icon className={classes.inputAdornmentIcon}>
                                                    lock_outline
                                                </Icon>
                                            </InputAdornment>,
                                          "type": "password",
                                          "autoComplete": "off",
                                          "onChange": this.handleChange,
                                          "onKeyDown": this.handleKeyDown
                                      }}
                                      labelText="Confirm Password"
                                      success={
                                          this.state.password_confirmation_valid === "success"
                                      }
                                  />
                              </CardBody>
                              <CardFooter
                                  className={classes.justifyContentCenter}
                                  style={{"paddingTop": "0px"}}
                              >
                                  <Button
                                      block
                                      color="success"
                                      onClick={(event) => this.handleResetPasswordClick(event)}
                                      simple
                                      size="lg"
                                  >
                                      Reset Password
                                  </Button>
                                  <Button
                                      block
                                      color="info"
                                      onClick={this.handleLoginClick}
                                      simple
                                      size="lg"
                                  >
                                      Log In
                                  </Button>
                              </CardFooter>
                          </Card>
                      </form>
                  </GridItem>
              </GridContainer>
          </div>
      );
  }
}

ResetPassword.propTypes = {
    "classes": PropTypes.object.isRequired,
    "reset_msg": PropTypes.string,
    "reset_status": PropTypes.string
};

const mapStateToProps = (state, props) => {
        helpers.hideLoading();
        return {
            "auth": state.auth.data,
            "reset_msg":
                state.auth && state.auth.data && state.auth.data.resetPasswordMessage
                    ? state.auth.data.resetPasswordMessage
                    : "",
            "reset_status":
                state.auth && state.auth.data && state.auth.data.authStatus
                    ? state.auth.data.authStatus
                    : ""
        };
    },

    mapDispatchToProps = (dispatch) => ({
        "doResetClientPassword": (token, username, props) => dispatch(doResetClientPassword(
            token,
            username,
            props
        ))
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withStyles(resetPasswordStyle)(ResetPassword)));
